import { Box, Container, Grid, Typography } from '@mui/material'
import React from 'react'
import './WhyProf.css'
import Divider from '@mui/material/Divider';

function WhoProf({ desc, title, titleLed, descLed }) {

    return (
        <Container>
            <Grid container>
                {/* <Grid item xs={12} md={6}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', }} >
                        <Typography
                            variant="h4"
                            component="h3"
                            sx={{
                                mb: "10px",
                                fontWeight: "bold",
                                color: "#76232d"
                            }}
                        >
                            {title}
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            color={"GrayText"}
                            sx={{
                                maxWidth: { md: "100%", xs: "100%" },
                                fontSize: 16,
                                lineHeight: 1.2,
                                p: 4,
                                // height: '250px'
                            }}
                            className="cardTestim"
                        >{desc}
                        </Typography>
                    </Box>
                </Grid> */}
                <Grid item xs={12} md={12}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', }} >
                        <Typography
                            variant="h4"
                            component="h3"
                            sx={{
                                mb: "10px",
                                fontWeight: "bold",
                                color: "#76232d"
                            }}>
                            {titleLed}
                            <Divider sx={{ borderColor: '#000', mt: 2, width: { md: '15%', xs: '60%' }, borderWidth: '1px' }} />
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            color={"GrayText"}
                            sx={{
                                maxWidth: { md: "90%", xs: "100%" },
                                fontSize: 15,
                                lineHeight: 1.2,
                                padding: 4,
                                textAlign: 'center',
                                margin: 'auto',
                                // height: '250px'
                            }}
                            className="cardTestim"
                        >{descLed}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>



            {/* <!-- Simple video example -->
                <!-- 'Big Buck Bunny' licensed under CC 3.0 by the Blender foundation. Hosted by archive.org -->
                <!-- Poster from peach.blender.org --> */}
            {/* <video autoPlay muted src={vid} loop>
                    Your browser does not support the video tag.
                </video> */}
            {/* <video
                    controls
                    src="https://archive.org/download/BigBuckBunny_124/Content/big_buck_bunny_720p_surround.mp4"
                    poster="./../../assets/Logo/logo.png" >
                    Sorry, your browser doesn't support embedded videos, but don't worry, you can
                </video> */}
        </Container>
    )
}

export default WhoProf